module.exports = __webpack_public_path__ + "static/media/christmas-tree-svg.eeeadccb.svg";